import React, { useState } from 'react';
import { QuickActions } from './QuickActions';
import { ManagedEnvironments, Environment } from './RecentScans';
import { CriticalNextStep } from './CriticalNextStep';
interface DashboardProps {
  onStartScan: () => void;
  onViewVulnerabilities: () => void;
  onConfigureScans: () => void;
  onAddAccount: () => void;
  onAddClient: () => void;
  onManageEnvironment: (env: Environment) => void;
  onViewClientVulns: (env: Environment) => void;
  onViewReport: (env: Environment, sections: string[]) => void;
  onOpenReportConfig: (env: Environment) => void;
  onViewBulletins: () => void;
}
export function Dashboard({
  onStartScan,
  onViewVulnerabilities,
  onConfigureScans,
  onAddAccount,
  onAddClient,
  onManageEnvironment,
  onViewClientVulns,
  onViewReport,
  onOpenReportConfig,
  onViewBulletins
}: DashboardProps) {
  const [activeClientIndex, setActiveClientIndex] = useState(0);
  // Mock data for MSP environments
  const environments: Environment[] = [{
    id: 'ENV-001',
    clientName: 'Acme Corp',
    type: 'Hybrid',
    status: 'healthy',
    identities: 12450,
    complianceScore: 94,
    overPrivileged: 12,
    lastSync: '2m ago'
  }, {
    id: 'ENV-002',
    clientName: 'Globex Inc',
    type: 'AWS',
    status: 'warning',
    identities: 3840,
    complianceScore: 78,
    overPrivileged: 45,
    lastSync: '15m ago'
  }, {
    id: 'ENV-003',
    clientName: 'Soylent Corp',
    type: 'On-Prem',
    status: 'critical',
    identities: 850,
    complianceScore: 62,
    overPrivileged: 128,
    lastSync: '1h ago'
  }, {
    id: 'ENV-004',
    clientName: 'Umbrella Corp',
    type: 'Azure',
    status: 'healthy',
    identities: 15200,
    complianceScore: 98,
    overPrivileged: 3,
    lastSync: '5m ago',
    govCloud: true,
    govCloudRegion: 'USGov Virginia',
    cmmcLevel: 3,
    complianceFrameworks: ['NIST 800-171', 'CMMC', 'FedRAMP High', 'ITAR']
  }, {
    id: 'ENV-005',
    clientName: 'Stark Ind',
    type: 'GCP',
    status: 'warning',
    identities: 5600,
    complianceScore: 85,
    overPrivileged: 22,
    lastSync: '30m ago',
    govCloud: true,
    govCloudRegion: 'us-gov-west1',
    cmmcLevel: 2,
    complianceFrameworks: ['NIST 800-171', 'CMMC', 'FedRAMP Moderate']
  }];

  // Problematic clients for dot navigation
  const problemClients = [...environments].filter(e => e.status === 'critical' || e.status === 'warning').sort((a, b) => a.complianceScore - b.complianceScore);
  const activePriorityClient = problemClients[activeClientIndex] || problemClients[0];
  const handleAddEnvironment = () => {
    onAddAccount();
  };
  const handleManageEnvironment = (id: string) => {
    console.log(`Managing environment ${id}`);
  };
  return <div className="max-w-7xl mx-auto px-6 py-8" data-id="element-350">
      {/* Page Header */}
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-10" data-id="element-351">
        <div data-id="element-352">
          <h1 className="text-3xl md:text-4xl font-bold text-white mb-2" data-id="element-353">
            Security <span className="text-astro-green" data-id="element-354">Command Center</span>
          </h1>
          <p className="text-astro-text-secondary text-lg" data-id="element-355">
            Point-in-time threat intelligence and security analytics
          </p>
        </div>
      </div>

      {/* Main Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6" data-id="element-356">
        {/* Left Column - Quick Actions */}
        <div className="lg:col-span-4" data-id="element-357">
          <QuickActions onStartScan={onStartScan} onViewVulnerabilities={onViewVulnerabilities} onGenerateReport={onOpenReportConfig} onViewBulletins={onViewBulletins} onAddClient={onAddClient} environments={environments} onViewClientVulns={onViewClientVulns} data-id="element-358" />

        </div>

        {/* Right Column - Critical Alert */}
        <div className="lg:col-span-8" data-id="element-359">
          <CriticalNextStep environments={environments} priorityClient={activePriorityClient} problemClients={problemClients} activeClientIndex={activeClientIndex} onClientIndexChange={setActiveClientIndex} onManageEnvironment={onManageEnvironment} onClientChange={() => {}} onViewClientVulns={onViewClientVulns} onViewReport={onViewReport} data-id="element-360" />

        </div>
      </div>

      {/* Managed Environments Section */}
      <ManagedEnvironments environments={environments} onAddEnvironment={handleAddEnvironment} onViewAll={onViewVulnerabilities} onManage={onManageEnvironment} onViewVulns={onViewClientVulns} onGenerateReport={onOpenReportConfig} data-id="element-361" />

    </div>;
}